import { cn } from "@/shared/lib";

// Кнопка, открывающая выбор героев или периода. Выбрано что-то — фон светлее,
// выбор открыт — золотая рамка.
export const filterTriggerClassName = (isActive: boolean): string =>
  cn(
    "h-[38px] gap-2 rounded-lg px-3 text-[13px] font-normal data-[state=open]:border-accent",
    isActive ? "border-border-strong bg-surface-raised" : "bg-background",
  );
